module.exports = function () {
    const header = document.querySelector(".header");
    if ( !header ) return;
    const hamBtn = header.querySelector(".header__ham");
    
    header?.querySelectorAll(".menu-item-has-children > a").forEach(link => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
        })
    })

    hamBtn.addEventListener("click", () => {
        document.body.classList.toggle("overflow-hidden");
        header.classList.toggle("open");
    });

    function handleHeaderScroll() {
        if (header) {
            let oldScroll = window.scrollY;

            function updateHeader() {
                const top = window.scrollY;

                if (top > 150 && oldScroll < top) {
                    header.classList.add("hide");
                } else if (oldScroll > top) {
                    header.classList.remove("hide");
                }
                
                if(header.classList.contains('header--light')) {
                    if (top < 30) {
                        header.classList.remove('header--dark');
                    } else {
                        header.classList.add('header--dark');
                    }
                }
             

                oldScroll = top;
            }

            // Fire on page load
            updateHeader();

            // Attach event listener for scroll
            window.addEventListener("scroll", updateHeader);
        }
    }
    handleHeaderScroll();
}